import { gsap } from 'gsap'

export function runCircleAnimation () {
  const tl = gsap.timeline({ delay: 0.5 })

  gsap.set('#quaters-circles', {
    svgOrigin: '400 400'
  })

  tl.to('#circle', {
    duration: 0.2,
    opacity: 0.25
  }, 'start')
    .to('#quaters-circles', {
      duration: 0.5,
      opacity: 1,
      delay: 1
    }, 'quaters')
    .to('#quaters-circles', {
      duration: 1,
      rotation: 360,
      ease: 'power4.out',
      delay: 1
    }, 'quaters')
    .to('#quaters-circles', {
      duration: 2.3,
      rotation: '+=180',
      ease: 'power4.out',
      delay: 0.5
    }, 'rotate')
    // .to('#quaters-circles', {
    //   duration: 2.3,
    //   rotation: '+=180',
    //   ease: 'power4.out',
    //   delay: 0
    // })
}
